import React from "react";
import "./notificationbox.css";
import Notification from "./Notification";
import { connect } from "react-redux";
import onClickOutside from "react-onclickoutside";

function NotificationBox({ rootData, className, close }) {
  NotificationBox.handleClickOutside = () => close();
  return (
    <React.Fragment>
      <div
        className={`notificationBox w-96 absolute bg-white -left-64 rounded-md shadow ${className}`}
      >
        <div className="pointerArrow absolute"></div>
        <div className="notificationBox__wrapper px-3">
          {rootData?.notificationData?.length > 0 ? rootData?.notificationData?.map((notifyData, idx) => {
            return <Notification key={idx} notifyData={notifyData} />
          }) : <div className="text-center py-3">
            <span className="manpro font-semibold text-lg block">Nothing To Show Here</span>
            <small className="manpro font-medium block">You'll be notified when the notification shows up.</small>
          </div>}
        </div>
      </div>
    </React.Fragment>
  );
}

const clickOutsideConfig = {
  handleClickOutside: () => NotificationBox.handleClickOutside,
};

const mapStateToProps = (state) => {
  return state;
};
export default connect(
  mapStateToProps,
  null
)(onClickOutside(NotificationBox, clickOutsideConfig));
